import SimplePracticeContactWidget from '../../../../../components/SimplePracticeContactWidget';
import { Wrapper, Paper, Content, Title, Text, FormSection } from './styles';

const BookFreeConsultation = ({ title, text }) => {
  return (
    <Wrapper>
      <Paper>
        <Content>
          <Title>{title}</Title>
          <Text>{text}</Text>
          <FormSection>
            <SimplePracticeContactWidget label="Contact Our Team" />
          </FormSection>
        </Content>
      </Paper>
    </Wrapper>
  );
};

export default BookFreeConsultation;
